import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Language from '../../../../lang/language';
import Translation from '../../../../lang/Translation';

export function ClickAndCollectDropshipContent(props) {
  const hasHomeDeliveryInfo = Language
    .doesTranslationExist(`delivery.description.dropship.header.two.${props.countryCode}`);
  return (
    <>
      <h3 data-test="ClickAndCollectDropshipContent__subheader">
        <Translation>delivery.description.dropship.header.one</Translation>
      </h3>
      <ul>
        <li><Translation>delivery.description.dropship.collection.content.one</Translation></li>
        <li><Translation>delivery.description.dropship.collection.content.two</Translation></li>
        <li><Translation>delivery.description.dropship.collection.content.three</Translation></li>
      </ul>
      
      {hasHomeDeliveryInfo && (
        <>
          <h3 data-test="ClickAndCollectDropshipContent__subheader">
            <Translation>{`delivery.description.dropship.header.two.${props.countryCode}`}</Translation>
          </h3>
          <ul>
            <li><Translation>delivery.description.dropship.home.delivery.content.one</Translation></li>
            <li><Translation>delivery.description.dropship.home.delivery.content.two</Translation></li>
            <li><Translation>delivery.description.dropship.home.delivery.content.three</Translation></li>
          </ul>
        </>
      )}
    </>
  );
}

ClickAndCollectDropshipContent.propTypes = {
  countryCode: PropTypes.string,
};

const mapStateToProps = state => ({
  countryCode: state.start.siteDataV2.countryCode,
});

export default connect(mapStateToProps)(ClickAndCollectDropshipContent);
